"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionEvaluationContext = void 0;
/**
 * A helper object that is provided to custom function implementations to provide additional contextual information.
 */
var FunctionEvaluationContext = /** @class */ (function () {
    function FunctionEvaluationContext(evaluator, node) {
        this.evaluator = evaluator;
        this.node = node;
    }
    /**
     * Evaluates the given AST node as a parameter for the current function at the given index, returning the value.
     * This method should be used instead of calling {@link Evaluator.evaluate} or {@link ASTNode.visit} on the parameter
     * node directly, as it handles pushing the correct {@link FunctionCallState} onto the stack.
     *
     * @param index The index of the parameter being evaluated.
     * @param param The AST node of the parameter.
     * @returns The value of the parameter expression.
     */
    FunctionEvaluationContext.prototype.evaluateFunctionParameter = function (index, param) {
        var _this = this;
        return this.evaluator.withState(this.node, { parameterIndex: index }, function () {
            return _this.evaluator.evaluate(param);
        });
    };
    return FunctionEvaluationContext;
}());
exports.FunctionEvaluationContext = FunctionEvaluationContext;
//# sourceMappingURL=functionEvaluationContext.js.map